export default "__VITE_ASSET__BF1o2Q7A__"